import React, { useEffect, useState } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { useDispatch, useSelector } from 'react-redux';
import { selectCountries, selectAccessToken } from '../../store/selectors';
import { getCountries } from '../../store/actions';

interface ICountryDropdownProperties {
  selectedValue: string[];
  onChange: (event: { value: string[] }) => void;
}

const CountryDropdown: React.FC<ICountryDropdownProperties> = ({ selectedValue, onChange }) => {
  const dispatch = useDispatch();
  const countries = useSelector(selectCountries);
  const accessToken = useSelector(selectAccessToken);
  const [options, setOptions] = useState<{ label: string; value: string }[]>([]);

  useEffect(() => {
    if (countries.length === 0 && accessToken) {
      dispatch(getCountries());
    }
  }, [dispatch, accessToken]);

  useEffect(() => {
    if (countries.length > 0) {
      const sortedOptions = countries
        .map((country) => ({
          label: `${country.code} - ${country.name}`,
          value: country.code,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
      setOptions(sortedOptions);
    }
  }, [countries]);

  return (
    <MultiSelect
      id="countryDropdown"
      value={selectedValue}
      options={options}
      onChange={onChange}
      placeholder="Select Countries"
      display="chip"
      filter
    />
  );
};

export default CountryDropdown;
